import {TopNavigationBar} from "@ui";
import React from "react";
import {useTheme} from "styled-components";
import styles, {
  cartButtonStyles,
  loginButtonStyles,
  searchButtonStyles,
} from "src/themes/baseTheme/components/Header/styles";
import dynamic from "next/dynamic";
import {logModuleLoadError} from "src/core/common/utils";
import DetailedSearchInputSection from "src/themes/baseTheme/elements/SearchInputSection/DetailedSearchInputSection";
import useHeaderProps from "src/core/common/hooks/useHeaderProps";
import Link from "src/core/common/components/modules/Link";
import useFeatureToggles from "src/core/common/hooks/useFeatureToggles";
import merge from "lodash/merge";
import get from "lodash/get";
import useSite from "src/core/sites/hooks/useSite";
import {SEARCH_COMPONENT_DISPLAY} from "@ui/components/TopNavigationBar/TopNavigationBar";

const SideMenu = dynamic(() =>
  import("src/core/common/components/collections/menu/side-menu/SideMenu").catch(
    logModuleLoadError("SideMenu")
  )
);

function TheColorFulHeader() {
  const site = useSite();
  const _theme = useTheme();
  const theme = {v2: merge({}, _theme.v2, get(_theme.v2, "overrides.appBar"))};
  const toggles = useFeatureToggles();
  const {
    logo,
    homeLinkUrl,
    options,
    setMenuOpen,
    isMenuOpen,
    sideMenuEnabled,
    loginButtonProps,
    cartButtonProps,
  } = useHeaderProps();

  return (
    <>
      <TopNavigationBar
        logoUrl={logo}
        mobileLogoUrl={logo}
        LinkComponent={Link}
        logoLinkUrl={homeLinkUrl}
        hideMenuButtonOnLargerViewport={false}
        styles={styles(theme, site)}
        hideLoginButton={toggles.isKiosk()}
        largeScreenOptions={options}
        largeScreenOptionsAlignment={"right"}
        logoPosition={"left"}
        searchComponentDisplay={SEARCH_COMPONENT_DISPLAY.full}
        SearchComponent={DetailedSearchInputSection}
        onClickMenuButton={() => setMenuOpen(true)}
        cartButtonProps={{
          ...cartButtonProps,
          highlight: true,
          styles: cartButtonStyles(theme, site),
        }}
        searchButtonProps={{
          outline: site.getUiConfiguration().search.outline,
          highlight: true,
          styles: searchButtonStyles(theme, site),
        }}
        loginButtonProps={{
          ...loginButtonProps,
          outline: site.getUiConfiguration().login.outline,
          styles: loginButtonStyles(theme, site),
        }}
      />
      {sideMenuEnabled && (
        <SideMenu logo={logo} isOpen={isMenuOpen} close={() => setMenuOpen(false)} />
      )}
    </>
  );
}

export default TheColorFulHeader;
